<template>
  <ContentWithHeader>
    <template #header>
      <button
        class="btn no-bg"
        @click="setPosSection('choose-product')">
        <i class="fas fa-times"/>
      </button>
    </template>
    <template #content>
      <div class="wrapper">
        <div class="custom">
          <BaseNotificationList
            :title="$t('message.notifications')"
            :items="notifications"
            :limitItems="10"
            @onClickReadAll="handleClickReadNotifyAll"
          >
            <template #item="{ itemData: item }">
              <BaseNotificationItemApprove
                v-if="[...NEED_APPROVE_ACCESS_STATUSES, ...NEED_APPROVE_ORDERS_STATUSES].includes(item.code)"
                :code="item.code"
                :platform="item.platform"
                :dateTime="item.created_at"
                :queueNumber="item.queue_number"
                :tableNumber="item.table_number"
                :orderDetail="getNotifyDetailText(item.metadata)"
                :isRead="item.is_read"
                :responseStatus="item.metadata.responseStatus"
                class="custom-wrapper-base-notification-approve"
                @onClickReject="handleClickReject(item)"
                @onClickApprove="handleClickApprove(item)"
                @onClickViewOrderNo="handleClickViewOrderNo(item)"
              />
              <BaseNotificationItemSimple
                v-else
                :code="item.code"
                :platform="item.platform"
                :dateTime="item.created_at"
                :queueNumber="item.queue_number"
                :tableNumber="item.table_number"
                :orderDetail="getNotifyDetailText(item.metadata)"
                :isRead="item.is_read"
                @onClickRead="handleClickReadNotify(item)"
                @onClickViewOrderNo="handleClickViewOrderNo(item)"
              />
            </template>
          </BaseNotificationList>
        </div>
      </div>
    </template>
  </ContentWithHeader>
</template>

<script>
import notificationMixin from '@/mixins/pos/notification'
import ContentWithHeader from '../common/ContentWithHeader.vue'
import BaseNotificationList from '../../../../../base/BaseNotificationList.vue'
import BaseNotificationItemApprove from '../../../../../base/BaseNotificationItemApprove.vue'
import BaseNotificationItemSimple from '../../../../../base/BaseNotificationItemSimple.vue'

export default {
  mixins: [notificationMixin],

  components: {
    ContentWithHeader,
    BaseNotificationList,
    BaseNotificationItemApprove,
    BaseNotificationItemSimple,
  },
}
</script>

<style scoped>
.custom >>> .wrapper-base-notification-approve, .custom >>> .wrapper-base-notification-simple {
  flex-direction: column;
}

.custom >>> .wrapper-base-notification-approve .action,
.custom >>> .wrapper-base-notification-simple .action {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/apps/pos/sale/mobile/include/NotificationList.vue